<template>
    <div>
        <div class="modal hide fade" id="modalPaymentGroup" tabindex="-1" role="dialog" aria-labelledby="modalPaymentGroup" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Payment {{ payment.group_no }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dt class="col-md-4">Company</dt>
                                <dd class="col-md-8">{{ payment.company }}</dd>

                                <dt class="col-md-4">Method</dt>
                                <dd class="col-md-8">{{ payment.method }}</dd>

                                <dt class="col-md-4">Category</dt>
                                <dd class="col-md-8">{{ payment.category }}</dd>

                                <dt class="col-md-4">Create Date</dt>
                                <dd class="col-md-8">{{ payment.payment_date | dateFormat('DD/MM/YYYY') }}</dd>

                                <dt class="col-md-4" v-if="payment.method_id === 3">Finish date</dt>
                                <dd class="col-md-8" v-if="payment.method_id === 3">{{ payment.finish_date | dateFormat('DD/MM/YYYY') }}</dd>

                                <dt class="col-md-4" v-if="payment.method_id === 3">Giro No.</dt>
                                <dd class="col-md-8" v-if="payment.method_id === 3">
                                  <span v-if="payment.giro_no === null">&nbsp;</span>
                                  <span v-else cl>{{ payment.giro_no }}</span>
                                </dd>

                                <dt class="col-md-4" v-if="payment.method_id === 3">Bank</dt>
                                <dd class="col-md-8" v-if="payment.method_id === 3">
                                  <span v-if="payment.bank_id === null">&nbsp;</span>
                                  <span v-else cl>{{ payment.bank_id }}</span>
                                </dd>

                                <dt class="col-md-4" v-if="payment.method_id === 3">Bank Name</dt>
                                <dd class="col-md-8" v-if="payment.method_id === 3">
                                  <span v-if="payment.bank_name === null">&nbsp;</span>
                                  <span v-else cl>{{ payment.bank_name }}</span>
                                </dd>
                            </div>
                            <div class="col-md-6">
                                <dt class="col-md-4">Amount</dt>
                                <dd class="col-md-8">
                                    {{ payment.total }}
                                </dd>

                                <dt class="col-md-4">Account</dt>
                                <dd class="col-md-8">
                                    <b>[{{ payment.account_code }}]</b> {{ payment.account }}
                                </dd>

                                <dt class="col-md-4">Customer</dt>
                                <dd class="col-md-6">
                                    {{ payment.customer }}
                                </dd>

                                <dt class="col-md-4">Uang Muka</dt>
                                <dd class="col-md-6">
                                    {{ totalUM | currency}}
                                </dd>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs nav-bordered">
                                    <li class="nav-item"><a href="#data-payment" data-toggle="tab" aria-expanded="false" class="nav-link active">Payment</a></li>
                                    <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                                    <li class="nav-item"><a href="#sales-data" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                                    <li class="nav-item"><a href="#um-data" data-toggle="tab" aria-expanded="false" class="nav-link">Uang Muka</a></li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="data-payment">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="table-responsive" v-if="payment.category === 'sales'">
                                                    <table class="table table-item table-sm table-hover table-striped">
                                                        <thead>
                                                            <th>Tgl.</th>
                                                            <th>Sale No.</th>
                                                            <th>Payment No</th>
                                                            <th>Notes</th>
                                                            <th class="text-right">Amount</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="p in payment.sales" :key="p.id">
                                                                <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                                <td>{{ p.sale_no }}</td>
                                                                <td>{{ p.payment_no }}</td>
                                                                <td>{{ p.notes }}</td>
                                                                <td class="text-right">{{ p.price | currency }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Subtotal</b></td>
                                                                <td class="text-right">{{ payment.subtotal | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Discount</b></td>
                                                                <td class="text-right">{{ payment.discount | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Total</b></td>
                                                                <td class="text-right">{{ payment.total | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Rounding</b></td>
                                                                <td class="text-right">{{ payment.round | currency }}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                                <div class="table-responsive" v-else-if="payment.category === 'purchasing'">
                                                    <table class="table table-item table-sm table-hover table-striped">
                                                        <thead>
                                                            <th>Tgl.</th>
                                                            <th>Purchasing No.</th>
                                                            <th>Payment No</th>
                                                            <th>Notes</th>
                                                            <th class="text-right">Amount</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="p in payment.purchasings" :key="p.id">
                                                                <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                                <td>{{ p.purchasing_no }}</td>
                                                                <td>{{ p.payment_no }}</td>
                                                                <td>{{ p.notes }}</td>
                                                                <td class="text-right">{{ p.price | currency }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Subtotal</b></td>
                                                                <td class="text-right">{{ payment.subtotal | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Discount</b></td>
                                                                <td class="text-right">{{ payment.discount | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Total</b></td>
                                                                <td class="text-right">{{ payment.total | currency }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-right"><b>Rounding</b></td>
                                                                <td class="text-right">{{ payment.round | currency }}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="journal">
                                        <div class="table-responsive">
                                            <table class="table table-sm table-item table-hover table-striped">
                                                <thead>
                                                <th>Journal Code</th>
                                                <th>Date</th>
                                                <th>Account Code</th>
                                                <th>Remark</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                </thead>
                                                <tbody>
                                                <tr v-for="j in payment.journals" :key="j.id">
                                                    <td>
                                                    <span v-if="j.level === 1">
                                                        <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                                        <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                                        <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                                    </span>
                                                    <span v-else></span>
                                                    </td>
                                                    <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                                    <td>{{ j.remark }}</td>
                                                    <td class="text-right">
                                                    <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                                    <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                                    <span v-else></span>
                                                    </td>
                                                    <td class="text-right">
                                                    <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                                    <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                                    <span v-else></span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="sales-data">
                                        <div class="table-responsive" v-if="payment.category === 'sales'">
                                            <table class="table table-sm table-item table-striped">
                                                <thead>
                                                    <th>Sale No</th>
                                                    <th>Payment No.</th>
                                                    <th>Date</th>
                                                    <th>Due Date</th>
                                                    <th>Customer</th>
                                                    <th>Salesman</th>
                                                    <th>Method</th>
                                                    <th class="text-right">Subtotal</th>
                                                    <th class="text-right">Discount</th>
                                                    <th class="text-right">Tax</th>
                                                    <th class="text-right">Total</th>
                                                    <th class="text-right">Outstanding</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="d in payment.saleData" :key="d.id">
                                                        <td v-if="d.level ===1"><b>{{ d.sale_no }}</b></td>
                                                        <td v-else>
                                                        <span class="ml-5">
                                                            <i>{{ d.payment_no }}</i>
                                                        </span>
                                                        </td>

                                                        <td>{{ d.group_no }}</td>

                                                        <td v-if="d.level === 1">{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                                        <td v-else>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>

                                                        <td v-if="d.level === 1">{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                                        <td v-else></td>

                                                        <td v-if="d.level === 1">{{ d.customer }}</td>
                                                        <td v-else></td>

                                                        <td v-if="d.level === 1">{{ d.salesman }}</td>
                                                        <td v-else></td>

                                                        <td v-if="d.level === 1"></td>
                                                        <td v-else>{{ d.method }}</td>

                                                        <td v-if="d.level === 1" class="text-right">{{ d.subtotal | currency }}</td>
                                                        <td v-else class="text-right"></td>

                                                        <td v-if="d.level === 1" class="text-right">{{ d.discount | currency }}</td>
                                                        <td v-else class="text-right"></td>

                                                        <td v-if="d.level === 1" class="text-right">{{ d.tax | currency }}</td>
                                                        <td v-else class="text-right"></td>

                                                        <td class="text-right">{{ d.total | currency }}</td>

                                                        <td v-if="d.level === 1" class="text-right">{{ d.outstanding | currency }}</td>
                                                        <td v-else class="text-right"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="table-responsive" v-else-if="payment.category === 'purchasing'">
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="um-data">
                                        <div class="table-responsive">
                                            <table class="table table-sm table-item table-hover table-striped">
                                                <thead>
                                                <th>Status</th>
                                                <th>Method</th>
                                                <th>Payment No</th>
                                                <th>Create Date</th>
                                                <th>Customer</th>
                                                <th>Ref No.</th>
                                                <th class="text-right">Total</th>
                                                <th>#</th>
                                                </thead>
                                                <tbody>
                                                <tr v-if="payment.refs.length == 0">
                                                    <td colspan="7">
                                                    <i>No Data</i>
                                                    </td>
                                                </tr>
                                                <tr v-for="r in payment.refs" :key="r.id">
                                                    <td>{{ r.status }}</td>
                                                    <td>{{ r.method_id }}</td>
                                                    <td>{{ r.payment_no }}</td>
                                                    <td>{{ r.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td>{{ r.customer_no }}</td>
                                                    <td>{{ r.ref_no }}</td>
                                                    <td class="text-right">{{ r.total | currency }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentGroupModal',
  computed: {
    ...mapState({
      payment: state => state.payments.paymentByNo
    }),
    totalPayment () {
      var discount = parseFloat(this.payment.discount.replace(/\./g, ''))
      var total = 0
      total = this.totalProcessPayment - this.totalUM - discount
      return total
    },
    totalRounding () {
      var totalPayment = parseFloat(this.payment.total.replace(/\./g, ''))
      var round = 0
      if (this.payment.method_id !== 4) {
        round = totalPayment - this.totalPayment
      }
      return round
    },
    totalProcessPayment () {
      var sum = 0
      var array = this.payment.sales
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.toString().replace(/\./g, ''))
      }
      return sum
    },
    totalUM () {
      var sum = 0
      if (this.payment.method_id !== 4) {
        var array = this.payment.refs
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    }
  }
}
</script>
